export const ADD_TOAST = 'loyalty/toast/ADD_TOAST';
export const REMOVE_TOAST = 'loyalty/toast/REMOVE_TOAST';
export const REMOVE_TOAST_AFTER_DELAY = 'loyalty/toast/REMOVE_TOAST_AFTER_DELAY';

export interface Toast {
  id: string;
  message: string;
  variant: 'success' | 'error' | 'warning' | 'info';
  position?: 'bottom-right' | 'bottom-center';
}

export interface LoyaltyToastState {
  toasts: Toast[];
}
